import { render } from "./text-input.vue?vue&type=template&id=8ab8b57c&lang=pug"
import script from "./text-input.vue?vue&type=script&setup=true&lang=js"
export * from "./text-input.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__